export const ACCESSOR_SIZE = 52;
export const OPTIONS_SIZE = 50;

const getColumnSize = (percent: number, totalWidth?: number) => {
  if (!totalWidth) {
    return undefined;
  }
  return (totalWidth - OPTIONS_SIZE - ACCESSOR_SIZE) * percent;
};

export const getColumns = (totalWidth?: number) => [
  {
    accessorKey: 'avatar',
    header: '',
    size: ACCESSOR_SIZE,
    accessory: true,
  },
  {
    accessorKey: 'name',
    header: 'Name',
    minSize: 48,
    size: getColumnSize(0.2, totalWidth),
    sx: { pl: 0 },
    enableResizing: true,
  },
  {
    accessorKey: 'email',
    header: 'Email',
    size: getColumnSize(0.2, totalWidth),
    minSize: 56,
    enableResizing: true,
  },
  {
    accessorKey: 'role',
    header: 'Role',
    size: getColumnSize(0.2, totalWidth),
    minSize: 48,
    enableResizing: true,
  },
  {
    accessorKey: 'company',
    header: 'Company',
    size: getColumnSize(0.2, totalWidth),
    minSize: 80,
    enableResizing: true,
  },
  {
    accessorKey: 'publisherIpi',
    header: 'Publisher IPI',
    size: getColumnSize(0.2, totalWidth),
    minSize: 100,
    enableResizing: true,
  },
  {
    accessorKey: 'gap',
    size: 0,
  },
  {
    accessorKey: 'options',
    size: OPTIONS_SIZE,
    isOptions: true,
  },
];
